import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';

import * as yup from 'yup';

/** User group member */
export interface UserGroupMemberFindInterface extends UserFindInterface {
  /** Is user group's supervisor */
  isSupervisor?: boolean;
}

/** User group member - DTO schema */
export const UserGroupMemberFindDto = SerdeDtoClass.from<UserFindInterface, UserGroupMemberFindInterface>(
  UserFindDto,
  SecurityDtoKeysEnum.USER_GROUP_MEMBER_FIND_DTO,
  {
    isSupervisor: {
      label: 'Руководитель группы',
      optional: true,
      serializer: booleanSchema,
    },
  },
);

/** User group response body */
export interface UserGroupFindInterface {
  /** Unique identifier */
  id: number;
  /** Display name */
  name: string;
  /**
   * Number of participant users. This value equals {@link UserGroupFindInterface.users} property length.
   * It's need to query groups with number of participant users without joining them.
   */
  usersCount: number;
  /** Participant users */
  users: UserGroupMemberFindInterface[];
}

/** User group response body - DTO schema */
export const UserGroupFindDto = SerdeDtoClass.create<UserGroupFindInterface>(SecurityDtoKeysEnum.USER_GROUP_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    sortable: true,
    serializer: yup.string(),
  },
  usersCount: {
    label: 'Количество участников',
    serializer: yup.number(),
  },
  users: {
    label: 'Участники',
    nested: UserGroupMemberFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
